import { cloneElement, forwardRef, ReactElement } from "react";
import { useClientEvents } from "hooks/use-client-events";
import { useHoverDwell } from "hooks/use-hover-dwell";
import { useSearchQuery } from "hooks/use-search";
import { useTrackingRef } from "hooks/use-tracking-ref";
import { HOVER_VIEW_MIN_MS } from "./thresholds";

interface IProps {
    productId: number;
    // Must forward its ref to a DOM element
    children: ReactElement;
}

export const ProductHoverView = forwardRef<HTMLElement, IProps>(({ productId, children }, forwardedRef) => {
    const [ref, mergedRef] = useTrackingRef(forwardedRef);
    const query = useSearchQuery();
    const { addEvent } = useClientEvents();

    useHoverDwell(ref, {
        dwellMs: HOVER_VIEW_MIN_MS,
        onDwell: () => addEvent({ type: "PRODUCT_VIEWED", refId: String(productId), payload: { source: "hover", query } }),
    });

    return cloneElement(children, { ref: mergedRef });
});
ProductHoverView.displayName = "ProductHoverView";
